/**
 * Sprint 12+I2 (04.07.2026) — Dean's v4-Fragen fuer den Pionier-Quick-Check.
 * Updated: Sprint 12+M5.2 (18.07.2026) — Content v1.1 aus content_v1_EDIT.json.
 *
 * 5 Situations-basierte Fragen mit A/B/C/D-Antworten. Fest zugeordnetes
 * Antwort→Fokustyp-Mapping (A=Eule, B=Biene, C=Katze, D=Hund). Scoring
 * erfolgt Backend-seitig (1 Punkt pro Antwort, Tie-Break Eule > Biene > Hund > Katze).
 */

export const ANTWORT_TO_FOKUSTYP = {
  A: "eule",
  B: "biene",
  C: "katze",
  D: "hund",
};

export const QUICK_CHECK_V4_QUESTIONS = [
  {
    id: 1,
    situation: "Ein Freund erzählt dir von einem Problem.",
    frage: "Was tust du?",
    options: [
      { letter: "C", fokustyp: "katze", text: "Hängt davon ab, ob das jetzt gerade passt." },
      { letter: "A", fokustyp: "eule", text: "Ich höre genau zu und versuche zu verstehen, was wirklich dahinter steckt." },
      { letter: "D", fokustyp: "hund", text: "Ich spüre, wie sie/er sich fühlt, und versuche zu helfen." },
      { letter: "B", fokustyp: "biene", text: "Ich frage nach konkreten Fakten und überlege, welche Lösung am sinnvollsten wäre." },
    ],
  },
  {
    id: 2,
    situation: "Ihr diskutiert die Wochenendplanung.",
    frage: "Was ist dir am wichtigsten?",
    options: [
      { letter: "B", fokustyp: "biene", text: "Ich mache einen Plan mit klaren Schritten, dann passt das." },
      { letter: "D", fokustyp: "hund", text: "Mir ist wichtig, dass wir beide zufrieden sind, nicht nur ich." },
      { letter: "A", fokustyp: "eule", text: "Ich will erstmal verstehen, welche Optionen es gibt und was wirklich Sinn macht." },
      { letter: "C", fokustyp: "katze", text: "Ich will selbst entscheiden, was mir Spaß macht — nicht was andere wollen." },
    ],
  },
  {
    id: 3,
    situation: "Eine Kollegin kommt ständig zu spät.",
    frage: "Wie reagierst du?",
    options: [
      { letter: "D", fokustyp: "hund", text: "Ich rede erstmal unter vier Augen mit ihr — vielleicht steckt was dahinter." },
      { letter: "C", fokustyp: "katze", text: "Ihre Sache - Sie soll selbst entscheiden, wie sie ihre Zeit organisiert." },
      { letter: "B", fokustyp: "biene", text: "Ich schlage eine klare Regel vor: Meetings beginnen pünktlich." },
      { letter: "A", fokustyp: "eule", text: "Ich sage ihr sachlich, dass das so nicht funktioniert — und will die Gründe verstehen." },
    ],
  },
  {
    id: 4,
    situation: "Dein Teenager verdreht die Augen bei deiner Frage.",
    frage: "Wie gehst du damit um?",
    options: [
      { letter: "A", fokustyp: "eule", text: "Ich will verstehen, warum sie/er so reagiert — ist es das Alter oder was anderes?" },
      { letter: "D", fokustyp: "hund", text: "Ich versuche zu erspüren, ob sie/er gerade Stress hat, und gehe darauf ein." },
      { letter: "C", fokustyp: "katze", text: "Ich lasse sie/ihn erstmal in Ruhe — zwingen bringt nichts." },
      { letter: "B", fokustyp: "biene", text: "Ich erkläre ruhig, warum mir die Sache wichtig ist, und erwarte, dass sie/er zuhört." },
    ],
  },
  {
    id: 5,
    situation: "In einer Gruppe stellt jemand deine Meinung infrage.",
    frage: "Was tust du?",
    options: [
      { letter: "C", fokustyp: "katze", text: "Ich denke mir: meine Meinung steht, ob andere das hören wollen, ist deren Sache." },
      { letter: "B", fokustyp: "biene", text: "Ich will, dass am Ende alle wissen, wo wir stehen — also kläre ich es strukturiert." },
      { letter: "D", fokustyp: "hund", text: "Mir ist wichtig, dass die Stimmung in der Gruppe gut bleibt — also halte ich mich zurück." },
      { letter: "A", fokustyp: "eule", text: "Ich bleibe sachlich und bringe meine Argumente klar auf den Punkt." },
    ],
  },
];

/**
 * PNG-Glyphen fuer die 4 Fokustypen (Brand-Assets aus /public/icons/).
 * Absichtlich keine Emojis — visuelle Konsistenz mit Landing-Page & Cockpit.
 */
export const FOKUSTYP_GLYPHS = {
  eule: "/icons/icon-eule.png",
  biene: "/icons/icon-biene.png",
  katze: "/icons/icon-katze.png",
  hund: "/icons/icon-hund.png",
};

/**
 * Tie-Break-Prioritaet: bei Gleichstand gewinnt der Fokustyp, der weiter vorne
 * in dieser Liste steht. (Dean v4: Eule > Biene > Hund > Katze.)
 */
export const TIE_BREAK_PRIORITY = ["eule", "biene", "hund", "katze"];
